// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"e59539fc","995":"a2768bd9"}[chunkId] + ".chunk.js";
};